import processingStyles from '@components/onboarding/layout/processing/processing.module.scss'
import { useLoaderAnimation } from '@lib/hooks/useAnimation'
import { useEffect, useState } from 'react'

import styles from './full-screen-loading.module.scss'

interface FullScreenLoadingProps {
    isVisible?: boolean
}

const FullScreenLoading: React.FC<FullScreenLoadingProps> = ({
    isVisible = true,
}) => {
    const [isMounted, setIsMounted] = useState(false)

    const loaderRef = useLoaderAnimation({
        enabled: isVisible && isMounted,
    })

    useEffect(() => {
        setIsMounted(true)
    }, [])

    if (!isVisible || !isMounted) return null

    return (
        <div className={styles.overlay}>
            <div
                ref={loaderRef}
                className={processingStyles.icon}
                style={{ width: 80, height: 80 }}
            />
        </div>
    )
}

export default FullScreenLoading
